import { render, staticRenderFns } from "./FireAlarm.vue?vue&type=template&id=4821d918&scoped=true&"
import script from "./FireAlarm.vue?vue&type=script&lang=js&"
export * from "./FireAlarm.vue?vue&type=script&lang=js&"
import style0 from "./FireAlarm.vue?vue&type=style&index=0&id=4821d918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821d918",
  null
  
)

export default component.exports